const dateFormatter = (datetimeStr) => {
  const datetime = new Date(datetimeStr)

  // Format the date and time
  return datetime.toLocaleDateString('fr-FR')
}
export default dateFormatter

// const dateFormatter = (datetimeStr) => {
//   if (!datetimeStr) return ""

//   const d = new Date(datetimeStr)
//   const day = String(d.getDate()).padStart(2, "0")
//   const month = String(d.getMonth() + 1).padStart(2, "0")
//   const year = d.getFullYear()

//   return `${day}/${month}/${year}`
// }
// export default dateFormatter
